import { organisation } from '../data/mockData';

const channels = [
  {
    label: 'Course applications',
    value: organisation.trainingEmail,
    href: `mailto:${organisation.trainingEmail}`,
    note: 'Send CV, certified ID and qualifications, and SAPS affidavit.',
  },
  {
    label: 'General enquiries and quotes',
    value: organisation.generalEmail,
    href: `mailto:${organisation.generalEmail}`,
    note: 'IT services, consulting, and corporate training.',
  },
  {
    label: 'Phone',
    value: organisation.phoneDisplay,
    href: `tel:${organisation.phoneDial}`,
    note: 'Available 24/7.',
  },
  {
    label: 'Location',
    value: organisation.location,
    href: null,
    note: 'Training delivered on site, remotely, or blended.',
  },
];

export default function Contact() {
  return (
    <>
      <section className="bg-hero-glow">
        <div className="container py-14 lg:py-20">
          <div className="max-w-3xl">
            <span className="eyebrow">Get in touch</span>
            <h1 className="mt-5 text-4xl leading-tight sm:text-5xl">
              Talk to Mokaleng IT
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-brand-900/65">
              Whether you are applying for a learnership or arranging training
              for a team, here is how to reach us.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white">
        <div className="section-shell">
          <div className="grid gap-5 sm:grid-cols-2">
            {channels.map((channel) => (
              <div key={channel.label} className="card-surface p-7">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-600">
                  {channel.label}
                </p>
                {channel.href ? (
                  <a
                    href={channel.href}
                    className="mt-3 block text-lg font-bold text-brand-950 underline-offset-4 hover:text-brand-700 hover:underline"
                  >
                    {channel.value}
                  </a>
                ) : (
                  <p className="mt-3 text-lg font-bold text-brand-950">
                    {channel.value}
                  </p>
                )}
                <p className="mt-2 text-sm leading-relaxed text-brand-900/60">
                  {channel.note}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-10 rounded-4xl bg-brand-gradient p-8 text-white sm:p-12">
            <h2 className="text-2xl text-white sm:text-3xl">
              Accredited by MICT SETA
            </h2>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-white/70">
              Accreditation number {organisation.accreditationNumber}, awarded in{' '}
              {organisation.accreditedSince}. Our programmes meet the quality
              standards set by SAQA and the QCTO.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
